import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { sleep } from '@/utils/helper';
import { $http } from '@/axios';
import store from '@/store';
import router from '@/plugins/router';

// 查询公告列表
export const queryNotices: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setNotices', { ...state.list, loading: true });
    const res: IPageData = await $http.post('/message/launcher/notice/list', payload);
    commit('setNotices', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setNotices', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查看详情
export const queryNoticeDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setNoticeDetail', { data: null, loading: true });
    const res = await $http.post(`/message/launcher/notice/get/${payload}`);
    commit('setNoticeDetail', { data: res });
    return res;
  } catch (e) {
    commit('setNoticeDetail', { data: null });
  }
};

// 添加公告
export const addNotice: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/message/launcher/notice/add', payload);
    commit('setLoading', false);
    store.commit('common/setToast', { visible: true, text: '添加成功, 2秒后跳转到列表页面' });
    await sleep(2);
    await router.push({ name: 'message-notice' });
  } catch (e) {
    commit('setLoading', false);
  }
};

// 编辑公告
export const editNotice: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/message/launcher/notice/modify', payload);
    commit('setLoading', false);
    store.commit('common/setToast', { visible: true, text: '编辑成功, 2秒后跳转到列表页面' });
    await sleep(2);
    await router.push({ name: 'message-notice' });
  } catch (e) {
    commit('setLoading', false);
  }
};

// 删除公告
export const deleteNotice: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/message/launcher/notice/delete', payload);
  } finally {
    commit('setConfirm', { visible: false, loading: false });
  }
};

// 发布公告
export const publishNotice: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/message/launcher/notice/publish', payload);
  } finally {
    commit('setConfirm', { visible: false, loading: false });
  }
};

// 置顶或取消置顶
export const topNotice: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/message/launcher/notice/setTop', payload);
  } finally {
    commit('setConfirm', { visible: false, loading: false });
  }
};
